import { Form, Formik } from "formik";
import React, { FC } from "react";
import Modal from 'react-modal';
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import closeIcon from '../../images/close.svg';
import { TimeTriggeredAction } from "../../models/TimeTriggeredAction";
import { TimeTriggeredActionCard } from "./TimeTriggeredActionCard";
import { Button } from '../button/Button';

interface TimeTriggeredActionProps {
    isOpen: boolean;
    onClose: () => void;
    saveTimeTriggeredAction: (values) => void;
    currentItem: TimeTriggeredAction
}

const TimeTriggeredActionModal: FC<TimeTriggeredActionProps> = ({ isOpen, onClose, saveTimeTriggeredAction, currentItem }) => {
    const { translate } = useLocale();

    return (
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
            className="bg-white border-none m-auto shadow select-none outline-none" >
            <Formik
                enableReinitialize={true}
                initialValues={currentItem}
                onSubmit={saveTimeTriggeredAction}>
                <Form>
                    <div className={`w-full p-2 border-b flex flex-row items-center bg-sidemenu-focus text-white justify-between`}>
                        <div className="flex flex-row">
                            <p className="pl-3 font-bold font text-white">{translate.byKey(TranslationKeys.timeTriggeredAction)}</p>
                        </div>
                        <img src={closeIcon} onClick={onClose} className="cursor-pointer mr-2" />
                    </div>
                    <div className="pt-3 pl-8 pr-0" style={{ width: '400px' }} >
                        <TimeTriggeredActionCard />
                    </div>
                    <div className="flex flex-row pb-3 pr-3 justify-end bg-white">
                        <div className="flex flex-row mt-4 mr-5">
                            <Button
                                variant="submit"
                                shape="pill"
                                id='submitBtn'
                                type='submit'>
                                {translate.byKey(TranslationKeys.confirm)}
                            </Button>
                        </div>
                    </div>
                </Form>
            </Formik>
        </Modal>
    )
}

export default TimeTriggeredActionModal;
